import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "chart-container"
};
import { ref, onMounted, onBeforeUnmount, watch, computed, markRaw } from 'vue';
import * as echarts from 'echarts';
export default {
  __name: 'DramaStatChart',
  props: {
    chartData: {
      type: Object,
      required: true,
      default: () => ({
        avg_duration: 0,
        median_duration: 0,
        min_duration: 0,
        max_duration: 0,
        avg_completeness: 0,
        median_completeness: 0,
        max_completeness: 0,
        min_completeness: 0,
        avg_solving_rate: 0,
        median_solving_rate: 0,
        max_solving_rate: 0,
        min_solving_rate: 0
      })
    },
    colors: {
      type: Array,
      default: () => ['#5470C6', '#91CC75', '#EE6666']
    },
    titles: {
      type: Array,
      default: () => {
        return Array.from({
          length: 10
        }, (_, index) => {
          return index.toString();
        });
      }
    }
  },

  setup(__props) {
    const props = __props;
    const chartRef = ref();
    const chartInstance = ref();
    let legend = ['duration', 'completeness', 'solving_rate'];
    const seriesData = computed(() => {
      const buffer = props.chartData['recent'] ?? {};
      return legend.map(title => {
        let data = buffer[title] ? buffer[title] : [];

        if (data.length > 1) {
          return {
            name: getLegendTitle(title),
            type: 'line',
            itemStyle: {},
            tooltip: {
              valueFormatter: function (value) {
                return valueFormatter(title, value);
              }
            },
            data: processDimension(data)
          };
        } else {
          return {
            name: getLegendTitle(title),
            type: 'bar',
            itemStyle: {},
            tooltip: {
              valueFormatter: function (value) {
                return valueFormatter(title, value);
              }
            },
            data: processDimension(data)
          };
        }
      });
    });

    const initChart = () => {
      if (!chartInstance.value) {
        chartInstance.value = markRaw(echarts.init(chartRef.value));
      }

      const option = {
        backgroundColor: 'transparent',
        legend: {
          data: legend.map(title => getLegendTitle(title)),
          left: '10%'
        },
        xAxis: {
          type: 'category',
          data: props.titles.map(item => {
            const num = 10 - parseInt(item);
            return num === 1 ? '上一场' : `${num}场前`;
          }),
          axisLabel: {
            color: '#4D626E'
          }
        },
        yAxis: {
          show: false
        },
        tooltip: {},
        series: seriesData.value
      };
      chartInstance.value.setOption(option);
    };

    const resetChart = () => {
      if (chartInstance.value) {
        chartInstance.value.setOption({
          series: seriesData.value
        });
      }
    };

    const processDimension = array => {
      if (!Array.isArray(array)) return array;
      const MAX_LENGTH = 10;
      const defaultFill = null;
      const paddingCount = MAX_LENGTH - array.length;
      const padding = Array(paddingCount).fill(defaultFill);
      return [...padding, ...array].slice(0, MAX_LENGTH);
    };

    const getLegendTitle = key => {
      switch (key) {
        case 'duration':
          return '演出时长';

        case 'completeness':
          return '完成度';

        case 'solving_rate':
          return '破解度';

        default:
          return '';
      }
    };

    const valueFormatter = (key, value) => {
      switch (key) {
        case 'duration':
          return `${value}h`;

        case 'completeness':
          return `${value}%`;

        case 'solving_rate':
          return `${value}%`;

        default:
          return '';
      }
    };

    watch(() => props.chartData, resetChart, {
      deep: true
    });
    onMounted(() => {
      window.addEventListener('resize', updateChart);
      initChart();
    });
    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateChart);

      if (chartInstance.value) {
        chartInstance.value.dispose();
      }
    });

    const updateChart = () => {
      if (!chartInstance.value) return;
      chartInstance.value.resize();
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("text", null, "演出统计（近10场）", -1)), _createElementVNode("div", {
        ref_key: "chartRef",
        ref: chartRef,
        class: "echarts"
      }, null, 512)]);
    };
  }

};